import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rappider-ui-page-layouts',
  templateUrl: './ui-page-layouts.component.html',
  styleUrls: ['./ui-page-layouts.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiPageLayoutsComponent { }
